import React from "react";
import { Redirect } from "react-router-dom";
import styles from "../../../Styles/FeedbackButton.module.scss";

type Props = {
  icon: JSX.Element;
  title: string;
  onClick?: () => void;
  link?: string;
};

type State = {
  shouldRedirect: boolean;
  redirectToUrl?: string;
};

export default class FeedbackStateChangeButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      shouldRedirect: false
    };
  }

  clickButton(e: React.MouseEvent) {
    if (this.props.onClick) {
      this.props.onClick();
    } else if (this.props.link) {
      this.setState(prevState => ({
        ...prevState,
        shouldRedirect: true,
        redirectToUrl: this.props.link
      }));
    }

    e.stopPropagation();
  }

  render() {
    if (this.state.shouldRedirect) {
      if (this.state.redirectToUrl) {
        return <Redirect to={this.state.redirectToUrl} push />;
      }
    }

    return (
      <a
        className={styles.feedbackButton}
        title={this.props.title}
        onClick={this.clickButton.bind(this)}
      >
        {this.props.icon}
      </a>
    );
  }
}
